// src/components/routes/Other/BackButton/BackButton.js

import React from "react";
import { useNavigate } from "react-router-dom";
import "./BackButton.css";

const BackButton = () => {
    const navigate = useNavigate();

    const handleBack = () => {
        if (window.history.length > 1) {
            navigate(-1);
        } else {
            navigate("/");
        }
    };

    return (
        <button
            type="button"
            className="app-nav-back-button"
            onClick={handleBack}
            aria-label="Go back"
        >
            <span className="app-nav-back-button-icon">
                <i className="fas fa-arrow-left"></i>
            </span>
            <span className="app-nav-back-button-label">Back</span>
        </button>
    );
};

export default BackButton;
